import { render, staticRenderFns } from "./informationReleaseManagement.vue?vue&type=template&id=5afd6c50&scoped=true&"
import script from "./informationReleaseManagement.vue?vue&type=script&lang=js&"
export * from "./informationReleaseManagement.vue?vue&type=script&lang=js&"
import style0 from "./informationReleaseManagement.vue?vue&type=style&index=0&id=5afd6c50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afd6c50",
  null
  
)

export default component.exports